import React, { useState, useEffect, useRef, useMemo, memo } from "react";
import "./header.css";
import logoWithText from "./assets/logowithtitle.png"; // Adjust the path as needed
import { NavLink } from "react-router";
import Modal from "./components/Modal";
import { logOut } from "./utils/firebaseUtils";
import { getDevice } from "./utils/deviceDetector";
import { useAuth } from "./AuthContext";

const Header = memo(() => {
  // menu stuff
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null); // Ref for the menu button

  const deviceType = useMemo(() => getDevice(), []); // Compute once and cache

  // modal stuff
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { profile } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target) // Exclude the menu button
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-left">
        <a href="/" className="logo-link">
          <img
            src={logoWithText}
            alt="Alpha Phi Alpha Fraternity, Inc."
            className="logo"
          />
        </a>
      </div>

      {/* Regular navigation (hidden on mobile) */}
      <nav className="nav-links">
        <NavLink to="/">Home</NavLink>

        {profile?.roles?.includes("reviewer") ? (
          <NavLink to="/submission-dashboard">Dashboard</NavLink>
        ) : (
          <NavLink to="/Account">Account</NavLink>
        )}

        {(!profile?.roles?.includes("applicant") ||
          profile?.roles?.includes("reviewer")) && (
          <NavLink to="/donate">Donate</NavLink>
        )}

        <NavLink to="/faq">FAQ</NavLink>
        {profile ? <NavLink onClick={openModal}>Logout</NavLink> : null}
      </nav>

      {/* Hamburger Menu Button (Only visible on small screens) */}
      <button
        ref={buttonRef} // Add ref to the button
        className="menu-button"
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      {/* Dropdown Menu */}
      <div className={`dropdown-menu ${menuOpen ? "show" : ""}`} ref={menuRef}>
        <NavLink to="/" onClick={() => setMenuOpen(false)}>
          Home
        </NavLink>

        {profile?.roles?.includes("reviewer") ? (
          <NavLink to="/submission-dashboard">Dashboard</NavLink>
        ) : (
          <NavLink to="/Account">Account</NavLink>
        )}
        <NavLink to="/donate" onClick={() => setMenuOpen(false)}>
          Donate
        </NavLink>
        <NavLink to="/faq" onClick={() => setMenuOpen(false)}>
          FAQ
        </NavLink>
        {profile ? <NavLink onClick={openModal}>Logout</NavLink> : null}
      </div>

      {/* user is requesting logOut */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="log-out-modal"
      >
        <h2>Are you sure you want to log out?</h2>
        <div className="btns">
          <span
            style={{
              paddingTop: deviceType === "iOS" ? "25px" : null,
              height: deviceType === "iOS" ? "5px" : null,
            }}
            className="primary-btn"
            onClick={() => {
              logOut();
              closeModal();
            }}
          >
            Log Out
          </span>
          <span
            style={{
              paddingTop: deviceType === "iOS" ? "25px" : null,
              height: deviceType === "iOS" ? "5px" : null,
            }}
            className="primary-btn"
            onClick={closeModal}
          >
            <p style={{ color: "#333" }}> Cancel</p>
          </span>
        </div>
      </Modal>
    </header>
  );
});

export default Header;
